export enum HexTileType {
    Blank,
    Safe,
    Dangerous,
    EscapePod,
    HumanStart,
    AlienStart
};